import { render, staticRenderFns } from "./InsightsChartLoader.vue?vue&type=template&id=2dfcbcc7&scoped=true"
import script from "./InsightsChartLoader.vue?vue&type=script&lang=js"
export * from "./InsightsChartLoader.vue?vue&type=script&lang=js"
import style0 from "./InsightsChartLoader.vue?vue&type=style&index=0&id=2dfcbcc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfcbcc7",
  null
  
)

export default component.exports